import { render, staticRenderFns } from "./OpenTextPoll.vue?vue&type=template&id=af51e8f2&scoped=true&"
import script from "./OpenTextPoll.vue?vue&type=script&lang=js&"
export * from "./OpenTextPoll.vue?vue&type=script&lang=js&"
import style0 from "./OpenTextPoll.vue?vue&type=style&index=0&id=af51e8f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af51e8f2",
  null
  
)

export default component.exports